// import React, { useState } from "react";
// import { MapPin, Phone, Home, Trash2, X, Pencil } from "lucide-react";
// import { Address } from "../../../types/userTypes";

// type Props = {
//   item: Address;
//   onEdit?: () => void;
//   onDelete?: () => void | Promise<void>;
// };

// const UserAddressCard = ({ item, onEdit, onDelete }: Props) => {
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [deleting, setDeleting] = useState(false);

//   const handleConfirmDelete = async () => {
//     try {
//       setDeleting(true);
//       await onDelete?.();
//       setShowConfirm(false);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   return (
//     <>
//       <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition">
//         <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
//           <div className="flex items-start gap-4">
//             <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center shrink-0">
//               <Home size={22} className="text-primary-color" />
//             </div>

//             <div className="space-y-3">
//               <div>
//                 <h2 className="font-semibold text-gray-900 text-base">
//                   {item.name}
//                 </h2>

//                 <span className="inline-block mt-2 text-xs font-medium bg-gray-100 text-primary-color px-3 py-1 rounded-md">
//                   Default Address
//                 </span>
//               </div>

//               <div className="flex items-start gap-2 text-sm text-gray-600">
//                 <MapPin size={17} className="mt-0.5 shrink-0 text-gray-500" />

//                 <p className="leading-6 break-words">
//                   {item.address}
//                   {item.locality && `, ${item.locality}`}, {item.city},{" "}
//                   {item.state} - {item.pinCode}
//                 </p>
//               </div>

//               <div className="flex items-center gap-2 text-sm text-gray-700">
//                 <Phone size={16} className="text-gray-500" />

//                 <p>
//                   <span className="font-medium">Mobile:</span> {item.mobile}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="flex sm:flex-col gap-2">
//             <button
//               type="button"
//               onClick={onEdit}
//               className="border border-primary-color text-primary-color rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 transition whitespace-nowrap flex items-center justify-center gap-2"
//             >
//               <Pencil size={15} />
//               Edit
//             </button>

//             <button
//               type="button"
//               onClick={() => setShowConfirm(true)}
//               className="border border-red-500 text-red-500 rounded-lg px-4 py-2 text-sm font-medium hover:bg-red-50 transition whitespace-nowrap flex items-center justify-center gap-2"
//             >
//               <Trash2 size={15} />
//               Delete
//             </button>
//           </div>
//         </div>
//       </div>

//       {showConfirm && (
//         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-5">
//             <div className="flex items-start justify-between gap-4">
//               <div>
//                 <h2 className="text-lg font-semibold text-gray-900">
//                   Delete Address?
//                 </h2>

//                 <p className="text-sm text-gray-500 mt-1">
//                   Are you sure you want to delete this address?
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 onClick={() => setShowConfirm(false)}
//                 disabled={deleting}
//                 className="text-gray-500 hover:text-gray-800 disabled:opacity-50"
//               >
//                 <X size={20} />
//               </button>
//             </div>

//             <div className="flex justify-end gap-3 mt-6">
//               <button
//                 type="button"
//                 onClick={() => setShowConfirm(false)}
//                 disabled={deleting}
//                 className="border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 disabled:opacity-50"
//               >
//                 Cancel
//               </button>

//               <button
//                 type="button"
//                 onClick={handleConfirmDelete}
//                 disabled={deleting}
//                 className="bg-red-500 text-white rounded-lg px-4 py-2 text-sm font-medium hover:bg-red-600 disabled:opacity-70"
//               >
//                 {deleting ? "Deleting..." : "Delete"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserAddressCard;




import React, { useState } from "react";
import { MapPin, Phone, Home, Trash2, X, Pencil, Briefcase } from "lucide-react";
import { Address } from "../../../types/userTypes";

type Props = {
  item: Address;
  onEdit?: () => void;
  onDelete?: () => void | Promise<void>;
};

const UserAddressCard = ({ item, onEdit, onDelete }: Props) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true);
      await onDelete?.();
      setShowConfirm(false);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center shrink-0">
              {item.addressType?.toLowerCase() === "work" ? (
                <Briefcase size={22} className="text-primary-color" />
              ) : (
                <Home size={22} className="text-primary-color" />
              )}
            </div>

            <div className="space-y-3">
              <div>
                <h2 className="font-semibold text-gray-900 text-base">
                  {item.name}
                </h2>

                {item.defaultAddress && (
                  <span className="inline-block mt-2 text-xs font-medium bg-gray-100 text-primary-color px-3 py-1 rounded-md">
                    Default Address
                  </span>
                )}
              </div>

              <div className="flex items-start gap-2 text-sm text-gray-600">
                <MapPin size={17} className="mt-0.5 shrink-0 text-gray-500" />

                <p className="leading-6 break-words">
                  {item.address}
                  {item.locality && `, ${item.locality}`}, {item.city},{" "}
                  {item.state} - {item.pinCode}
                </p>
              </div>

              <div className="flex items-center gap-2 text-sm text-gray-700">
                <Phone size={16} className="text-gray-500" />

                <p>
                  <span className="font-medium">Mobile:</span> {item.mobile}
                </p>
              </div>
            </div>
          </div>

          <div className="flex sm:flex-col gap-2">
            <button
              type="button"
              onClick={onEdit}
              className="border border-primary-color text-primary-color rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 transition whitespace-nowrap flex items-center justify-center gap-2"
            >
              <Pencil size={15} />
              Edit
            </button>

            <button
              type="button"
              onClick={() => setShowConfirm(true)}
              className="border border-red-500 text-red-500 rounded-lg px-4 py-2 text-sm font-medium hover:bg-red-50 transition whitespace-nowrap flex items-center justify-center gap-2"
            >
              <Trash2 size={15} />
              Delete
            </button>
          </div>
        </div>
      </div>

      {showConfirm && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">
                  Delete Address?
                </h2>

                <p className="text-sm text-gray-500 mt-1">
                  Are you sure you want to delete this address?
                </p>
              </div>

              <button
                type="button"
                onClick={() => setShowConfirm(false)}
                disabled={deleting}
                className="text-gray-500 hover:text-gray-800 disabled:opacity-50"
              >
                <X size={20} />
              </button>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={() => setShowConfirm(false)}
                disabled={deleting}
                className="border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium hover:bg-gray-100 disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleConfirmDelete}
                disabled={deleting}
                className="bg-red-500 text-white rounded-lg px-4 py-2 text-sm font-medium hover:bg-red-600 disabled:opacity-70"
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserAddressCard;